import { useRef, useMemo, useEffect, useState } from 'react';
import { useTopic } from './useTopic'; // Ajustez le chemin selon votre structure

export const useSectionRefs = (defaultScrollAdjust = 100) => {
  const { topic, isLoading, LoadingComponent } = useTopic();
  
  // Créer les refs une seule fois quand le topic change
  const refs = useMemo(() => {
    if (topic?.subtitles) {
      return topic.subtitles.map(() => ({ current: null }));
    }
    return [];
  }, [topic?.subtitles]);

  // Créer anchorsParts basé sur les refs et les subtitles
  const anchorsParts = useMemo(() => {
    if (topic?.subtitles) {
      return topic.subtitles.map((title, index) => ({
        ref: refs[index],
        content: title,
        scrollAdjust: defaultScrollAdjust
      }));
    }
    return [];
  }, [topic?.subtitles, refs, defaultScrollAdjust]);

  return {
    anchorsParts,
    isLoading,
    LoadingComponent,
    topic
  };
};